export interface ComicChapter {
  id: string;
  title: string;
  chapterNumber: number;
  updateDate: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  coverImage: string;
  description: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  favorites: number;
  updateDate: string;
  chapters: ComicChapter[];
  tags: string[];
}

export const comics: Comic[] = [
  {
    id: 'dongdong-zahuopu',
    title: '洞洞杂货铺',
    author: '墨白',
    category: 'richang',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20manga-style%20illustration%20of%20a%20cozy%20mysterious%20general%20store%20with%20warm%20lighting%20and%20magical%20objects%20on%20wooden%20shelves%2C%20anime%20art%20style%2C%20soft%20warm%20colors%2C%20clean%20composition%2C%20Japanese%20manga%20cover%20aesthetic&width=800&height=1060&seq=comic-cover-01&orientation=portrait',
    description: '在一个不起眼的小巷深处，有一家名为"洞洞杂货铺"的小店。这里的每一件商品都藏着一个不为人知的故事。店主是一位神秘的年轻人，他不仅能满足顾客的各种奇怪需求，还能通过商品带领顾客进入完全不同的世界。温馨治愈中带着奇幻色彩，每一话都是一个独立又相连的温暖故事。',
    status: '连载中',
    rating: 9.6,
    views: 1285000,
    favorites: 86200,
    updateDate: '2026-08-05',
    tags: ['治愈', '奇幻', '日常', '单元剧'],
    chapters: [
      { id: 'ch-001', title: '第一话：会说话的雨伞', chapterNumber: 1, updateDate: '2026-06-01' },
      { id: 'ch-002', title: '第二话：记忆中的糖果罐', chapterNumber: 2, updateDate: '2026-06-08' },
      { id: 'ch-003', title: '第三话：通往过去的明信片', chapterNumber: 3, updateDate: '2026-06-15' },
      { id: 'ch-004', title: '第四话：能看见未来的眼镜', chapterNumber: 4, updateDate: '2026-06-22' },
      { id: 'ch-005', title: '第五话：永远不会空的茶杯', chapterNumber: 5, updateDate: '2026-06-29' },
      { id: 'ch-006', title: '第六话：月光编织的围巾', chapterNumber: 6, updateDate: '2026-07-06' },
      { id: 'ch-007', title: '第七话：收藏星光的玻璃瓶', chapterNumber: 7, updateDate: '2026-07-13' },
      { id: 'ch-008', title: '第八话：通往梦境的枕头', chapterNumber: 8, updateDate: '2026-07-20' },
      { id: 'ch-009', title: '第九话：会唱歌的音乐盒', chapterNumber: 9, updateDate: '2026-07-27' },
      { id: 'ch-010', title: '第十话：时光倒流的怀表', chapterNumber: 10, updateDate: '2026-08-03' },
    ],
  },
  {
    id: 'xingchen-biji',
    title: '星辰笔记',
    author: '林间月',
    category: 'qihuan',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20manga%20cover%20showing%20a%20girl%20holding%20a%20glowing%20notebook%20under%20a%20starry%20night%20sky%2C%20fantasy%20anime%20art%20style%2C%20soft%20blue%20and%20purple%20tones%2C%20dreamy%20atmosphere%2C%20clean%20manga%20composition&width=800&height=1060&seq=comic-cover-02&orientation=portrait',
    description: '高中生苏星在一次偶然的机会下获得了一本神秘的笔记，只要在上面写下愿望，愿望就会以一种意想不到的方式实现。但随着愿望越来越多，她发现每一次实现都伴随着相应的代价。这是一部关于成长、选择与责任的奇幻故事。',
    status: '连载中',
    rating: 9.3,
    views: 956000,
    favorites: 65300,
    updateDate: '2026-08-04',
    tags: ['奇幻', '校园', '成长', '治愈'],
    chapters: [
      { id: 'ch-101', title: '第一话：从天而降的笔记本', chapterNumber: 1, updateDate: '2026-05-01' },
      { id: 'ch-102', title: '第二话：第一个愿望', chapterNumber: 2, updateDate: '2026-05-08' },
      { id: 'ch-103', title: '第三话：代价', chapterNumber: 3, updateDate: '2026-05-15' },
      { id: 'ch-104', title: '第四话：笔记的秘密', chapterNumber: 4, updateDate: '2026-05-22' },
      { id: 'ch-105', title: '第五话：新的使用者', chapterNumber: 5, updateDate: '2026-05-29' },
    ],
  },
  {
    id: 'jianhun',
    title: '剑魂',
    author: '铁骨',
    category: 'wuxia',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20manga%20cover%20of%20a%20swordsman%20in%20traditional%20Chinese%20martial%20arts%20clothing%20holding%20a%20glowing%20sword%2C%20dramatic%20ink%20wash%20painting%20style%2C%20anime%20aesthetic%2C%20bold%20brushstrokes%2C%20dark%20and%20gold%20tones&width=800&height=1060&seq=comic-cover-03&orientation=portrait',
    description: '少年剑客林逸在家族被灭门后，携带着祖传的剑谱踏上了复仇与成长之路。在江湖中，他遇到了形形色色的人物，经历了无数生死考验，逐渐领悟到剑道的真谛不仅仅在于杀伐，更在于守护。一部热血的武侠传奇！',
    status: '已完结',
    rating: 9.5,
    views: 2150000,
    favorites: 128000,
    updateDate: '2026-07-15',
    tags: ['武侠', '热血', '江湖', '成长'],
    chapters: [
      { id: 'ch-201', title: '第一话：灭门之夜', chapterNumber: 1, updateDate: '2025-10-01' },
      { id: 'ch-202', title: '第二话：逃出生天', chapterNumber: 2, updateDate: '2025-10-08' },
      { id: 'ch-203', title: '第三话：拜师学艺', chapterNumber: 3, updateDate: '2025-10-15' },
      { id: 'ch-204', title: '第四话：初入江湖', chapterNumber: 4, updateDate: '2025-10-22' },
      { id: 'ch-205', title: '第五话：剑指天下', chapterNumber: 5, updateDate: '2025-10-29' },
    ],
  },
  {
    id: 'mishi-xiaoyuan',
    title: '迷失校园',
    author: '夜雨',
    category: 'xuanyi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20suspenseful%20manga%20cover%20showing%20students%20in%20school%20uniforms%20standing%20in%20an%20empty%20school%20corridor%20with%20eerie%20shadows%2C%20mystery%20thriller%20anime%20style%2C%20dark%20atmosphere%2C%20cool%20tones&width=800&height=1060&seq=comic-cover-04&orientation=portrait',
    description: '转学生白晓来到新学校后，发现这所学校隐藏着许多不可告人的秘密。每到午夜，学校的走廊里会传来奇怪的脚步声，而一个个学生开始神秘失踪。白晓和几个同学组成了调查小组，试图揭开学校背后的真相。',
    status: '连载中',
    rating: 9.1,
    views: 782000,
    favorites: 48900,
    updateDate: '2026-08-03',
    tags: ['悬疑', '校园', '推理', '惊悚'],
    chapters: [
      { id: 'ch-301', title: '第一话：新来的转学生', chapterNumber: 1, updateDate: '2026-04-01' },
      { id: 'ch-302', title: '第二话：午夜脚步声', chapterNumber: 2, updateDate: '2026-04-08' },
      { id: 'ch-303', title: '第三话：消失的同学', chapterNumber: 3, updateDate: '2026-04-15' },
      { id: 'ch-304', title: '第四话：地下室的入口', chapterNumber: 4, updateDate: '2026-04-22' },
    ],
  },
  {
    id: 'gaoxiao-riji',
    title: '搞笑日记',
    author: '哈哈',
    category: 'gaoxiao',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20colorful%20and%20funny%20manga%20cover%20with%20exaggerated%20comic%20expressions%20of%20characters%20in%20everyday%20funny%20situations%2C%20bright%20and%20vibrant%20colors%2C%20humorous%20anime%20art%20style%2C%20clean%20composition&width=800&height=1060&seq=comic-cover-05&orientation=portrait',
    description: '平凡高中生王小明的爆笑日常！从上课睡觉被老师抓到，到食堂抢饭大作战，再到和损友们一起搞出的各种乌龙事件。每一话都能让你笑到肚子疼，是缓解压力的最佳良药！',
    status: '连载中',
    rating: 9.4,
    views: 1670000,
    favorites: 98500,
    updateDate: '2026-08-05',
    tags: ['搞笑', '校园', '日常', '轻松'],
    chapters: [
      { id: 'ch-401', title: '第一话：迟到的艺术', chapterNumber: 1, updateDate: '2026-01-01' },
      { id: 'ch-402', title: '第二话：食堂大作战', chapterNumber: 2, updateDate: '2026-01-08' },
      { id: 'ch-403', title: '第三话：考试风云', chapterNumber: 3, updateDate: '2026-01-15' },
      { id: 'ch-404', title: '第四话：体育课的悲剧', chapterNumber: 4, updateDate: '2026-01-22' },
      { id: 'ch-405', title: '第五话：愚人节特别篇', chapterNumber: 5, updateDate: '2026-01-29' },
      { id: 'ch-406', title: '第六话：班主任的突击', chapterNumber: 6, updateDate: '2026-02-05' },
    ],
  },
  {
    id: 'yinghua-lianqu',
    title: '樱花恋曲',
    author: '春风',
    category: 'lianai',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20manga%20cover%20with%20cherry%20blossoms%20falling%20around%20two%20high%20school%20students%20sharing%20a%20gentle%20moment%2C%20soft%20pink%20and%20white%20color%20palette%2C%20sweet%20anime%20art%20style%2C%20dreamy%20spring%20atmosphere&width=800&height=1060&seq=comic-cover-06&orientation=portrait',
    description: '在樱花盛开的季节，内向的女孩苏樱遇到了阳光开朗的转学生林风。两个性格截然不同的人在校园生活中慢慢靠近，一段青涩美好的恋情在樱花树下悄然绽放。但毕业的钟声即将响起，他们的未来会走向何方？',
    status: '已完结',
    rating: 9.2,
    views: 1340000,
    favorites: 75800,
    updateDate: '2026-06-20',
    tags: ['恋爱', '校园', '青春', '治愈'],
    chapters: [
      { id: 'ch-501', title: '第一话：樱花树下的相遇', chapterNumber: 1, updateDate: '2025-12-01' },
      { id: 'ch-502', title: '第二话：同桌的你', chapterNumber: 2, updateDate: '2025-12-08' },
      { id: 'ch-503', title: '第三话：图书馆的秘密', chapterNumber: 3, updateDate: '2025-12-15' },
      { id: 'ch-504', title: '第四话：夏日祭典', chapterNumber: 4, updateDate: '2025-12-22' },
    ],
  },
  {
    id: 'rexue-lanqiu',
    title: '热血篮球',
    author: '飞人',
    category: 'rexue',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20sports%20manga%20cover%20showing%20a%20basketball%20player%20dunking%20with%20intense%20action%2C%20energetic%20anime%20art%20style%2C%20warm%20orange%20and%20red%20tones%2C%20dramatic%20motion%20lines%2C%20sports%20manga%20aesthetic&width=800&height=1060&seq=comic-cover-07&orientation=portrait',
    description: '身高只有168cm的少年叶凡，凭借惊人的弹跳力和不懈的努力，带领默默无闻的青云高中篮球队一路杀入全国大赛。面对强敌，他们用汗水和热血书写着属于自己的篮球传奇！全国制霸，不只是梦想！',
    status: '连载中',
    rating: 9.7,
    views: 2890000,
    favorites: 156000,
    updateDate: '2026-08-04',
    tags: ['热血', '体育', '篮球', '竞技'],
    chapters: [
      { id: 'ch-601', title: '第一话：168cm的奇迹', chapterNumber: 1, updateDate: '2025-08-01' },
      { id: 'ch-602', title: '第二话：入队测试', chapterNumber: 2, updateDate: '2025-08-08' },
      { id: 'ch-603', title: '第三话：第一次练习赛', chapterNumber: 3, updateDate: '2025-08-15' },
      { id: 'ch-604', title: '第四话：宿命的对手', chapterNumber: 4, updateDate: '2025-08-22' },
      { id: 'ch-605', title: '第五话：县大赛开幕', chapterNumber: 5, updateDate: '2025-08-29' },
      { id: 'ch-606', title: '第六话：绝境反击', chapterNumber: 6, updateDate: '2025-09-05' },
    ],
  },
  {
    id: 'xingji-langzi',
    title: '星际浪子',
    author: '星河',
    category: 'kehuan',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20manga%20cover%20showing%20a%20space%20traveler%20in%20a%20futuristic%20suit%20standing%20on%20an%20alien%20planet%20with%20starships%20in%20the%20background%2C%20cyberpunk%20anime%20style%2C%20cool%20neon%20tones%2C%20epic%20composition&width=800&height=1060&seq=comic-cover-08&orientation=portrait',
    description: '公元2350年，人类已经遍布银河系。赏金猎人陆铭驾驶着自己的飞船穿梭于各个星球之间，接下各种危险的委托。在一次看似普通的任务中，他意外发现了一个足以改变整个银河系格局的秘密。',
    status: '连载中',
    rating: 9.0,
    views: 867000,
    favorites: 52300,
    updateDate: '2026-08-02',
    tags: ['科幻', '冒险', '星际', '机甲'],
    chapters: [
      { id: 'ch-701', title: '第一话：赏金猎人', chapterNumber: 1, updateDate: '2026-03-01' },
      { id: 'ch-702', title: '第二话：神秘委托', chapterNumber: 2, updateDate: '2026-03-08' },
      { id: 'ch-703', title: '第三话：废弃空间站', chapterNumber: 3, updateDate: '2026-03-15' },
    ],
  },
];

export const featuredComicIds = ['dongdong-zahuopu', 'rexue-lanqiu', 'jianhun', 'gaoxiao-riji'];

export const hotComicIds = ['dongdong-zahuopu', 'rexue-lanqiu', 'gaoxiao-riji', 'xingchen-biji', 'yinghua-lianqu', 'jianhun'];

export const newUpdateComicIds = ['dongdong-zahuopu', 'gaoxiao-riji', 'xingchen-biji', 'rexue-lanqiu', 'mishi-xiaoyuan', 'xingji-langzi'];

export function getComicById(id: string): Comic | undefined {
  return comics.find(c => c.id === id);
}

export function getComicsByCategory(slug: string): Comic[] {
  return comics.filter(c => c.category === slug);
}

export function getChapterById(comicId: string, chapterId: string): ComicChapter | undefined {
  const comic = getComicById(comicId);
  return comic?.chapters.find(ch => ch.id === chapterId);
}